import {
  SET_XML_STRING_ARRAY,
  SET_FIND_ALL_LIST,
  SET_IS_EDITMODE,
  INIT_DATA,
  UPDATE_READ_ONLY,
  SET_VIDEO_FPS,
} from "./types";

import DataObj from "../class/DataObj";
import TimeUtils from "../helper/TimeUtils";
import StringUtils from "../helper/StringUtils";
import ApiUtils from "../helper/ApiUtils";
import DataObjArray from "../class/DataObjArray";
import WaveformView from "../components/drogable/WaveformView";

/**
 * 確認本地FPS
 * */
export const checkLocalStorageVideoFps = (videoFps) => (dispatch) => {
  dispatch({
    type: SET_VIDEO_FPS,
    payload: parseFloat(videoFps),
  });
};

/**
 * 設定本地 FPS
 * */
export const setVideoFPS = (fps) => (dispatch) => {
  dispatch({
    type: SET_VIDEO_FPS,
    payload: fps,
  });
};

/**
 * 切換編輯模式
 * @return result bool 確認是否
 * */
export const setIsEditMode = (result) => (dispatch) => {
  dispatch({
    type: SET_IS_EDITMODE,
    payload: result,
  });

  //顯示編輯table
  dispatch({
    type: UPDATE_READ_ONLY,
    payload: !result,
  });
};

/**
 * 檢查本地的 playerEditingData
 * @return bool 確認有無存擋
 * */
export const checkLocalPlayerEditingData =
  (playerEditingData, findFrameSplitValue, videoFps) => (dispatch) => {
    if (playerEditingData !== null) {
      //顯查後更新
      finalEditTableCheckAndSave(
        dispatch,
        playerEditingData,
        findFrameSplitValue,
        videoFps,
        0,
        playerEditingData.length - 1
      );

      return true;
    } else {
      return false;
    }
  };

/**
 * 調整row內容
 * @param playerEditingData 現有資料
 * @param change 使用者調整內容
 * */
export const afterCellChange =
  (playerEditingData, rowIndex, key, newValue, videoFps, findFrameSplitValue) =>
  (dispatch) => {
    // console.log(`afterCellChange ${change}  `);
    //todo:檢察更新動作

    //新資料
    let newplayerEditingData = playerEditingData;

    //資料Row
    let currentObj = new DataObj(newplayerEditingData[rowIndex]);
    currentObj.setTSubType(WaveformView.projectSubType);
    currentObj[key] = newValue; //內容設定

    // console.log(`afterCellChange ${key}  `);

    if (key !== "Duration" && key !== "Length") {
      if (key === "In" || key === "Out") {
        const timeCode = StringUtils.ckeckOnlyEightNumber(newValue);

        if (key === "In") {
          currentObj.setInt(timeCode);
        }

        if (key === "Out") {
          currentObj.setOut(timeCode);
        }

        //duration

        if (currentObj.duration < 0) {
          alert(`Duration errpr`);
          return;
        }
      }

      //顯查後更新
      finalEditTableCheckAndSave(
        dispatch,
        playerEditingData,
        findFrameSplitValue,
        videoFps,
        rowIndex,
        parseFloat(rowIndex) + 1
      );
    }

    return newplayerEditingData;
  };

/**
 * 設定 isShowFindAllViewList
 * */
export const setIsShowFindAllViewList = (result) => (dispatch) => {
  dispatch({
    type: SET_FIND_ALL_LIST,
    payload: result,
  });
};

/**
 * 用戶使用xml檔案，此處獲取xml p的文字內容
 * */
export const setXMLstringArray = () => (dispatch) => {
  let stringArray = [];

  // console.log(ReactHtmlParser(xmlString));

  dispatch({
    type: SET_XML_STRING_ARRAY,
    payload: stringArray,
  });
};

/**
 * 透過時間來設定
 * @param  frameNum 用戶指定位置
 * */
export const goToTimeline =
  (frameNum, tableData, videoFps, data) => (dispatch) => {
    let startSecond = frameNum / videoFps;

    let lineNum = TimeUtils.secondsConvertToRowIndew(
      startSecond,
      videoFps,
      data
    );

    return lineNum;
  };

/**
 * 移動到 table 行數
 * @param  lineNum 移動位置
 * */
// export const goToLine = (lineNum) => dispatch => {
//
//     dispatch({
//         type: SET_TABLE_SELECT_CELL,
//         payload: lineNum
//     });
// }

/**
 * 執行　Timecodeshift
 * */
export const activeTimecodeshift =
  (
    stringData,
    videoFps,
    findFrameSplitValue,
    tProjectDetialId,
    distance,
    firstDataIndex,
    lastDataIndex
  ) =>
  (dispatch) => {
    let data = stringData.map((request, index) => {
      let beginFrameNumber = TimeUtils.timeString_convertTo_frame(request.In);
      let endFrameNumber = TimeUtils.timeString_convertTo_frame(request.Out);

      if (index >= firstDataIndex && index <= lastDataIndex) {
        beginFrameNumber += parseFloat(distance);
        endFrameNumber += parseFloat(distance);
      }

      //get frame number
      let durationFrame =
        parseFloat(endFrameNumber) - parseFloat(beginFrameNumber);
      let duration = TimeUtils.getTimeStringFrom_FrameCount(
        durationFrame,
        videoFps
      );

      let start = TimeUtils.getTimeStringFrom_FrameCount(
        beginFrameNumber,
        videoFps
      );
      let end = TimeUtils.getTimeStringFrom_FrameCount(
        endFrameNumber,
        videoFps
      );

      //秒數記錄
      let start_seconds = TimeUtils.getTimeStringFrom_FrameCount(
        beginFrameNumber,
        videoFps
      );
      let end_seconds = TimeUtils.getTimeStringFrom_FrameCount(
        endFrameNumber,
        videoFps
      );

      return {
        In: start,
        Out: end,
        start: start_seconds,
        end: end_seconds,
        ShotChange: request.ShotChange,
        Duration: duration,
        Memo: request.Memo,
        Source: request.Source,
        SubtitleCaption: request.SubtitleCaption,
        Length: StringUtils.getStringLength(request.SubtitleCaption),
        Position: request.Position,
      };
    });

    //新增
    // ApiUtils.post_sql(`${ApiUtils.post_AddDetialJsonData}`,{
    //     "tProjectDetialId":tProjectDetialId,
    //     "jsonstring":JSON.stringify(stringData)
    // });

    //顯查後更新
    finalEditTableCheckAndSave(
      dispatch,
      data,
      findFrameSplitValue,
      videoFps,
      0,
      data.length - 1
    );

    return stringData;
  };
/**
 * 使用讀取到的　SRT　來產生 表格資料
 * @param data 透過XMLParser來產生的資料
 * @param videoFps 影片幀數
 * */
export const setPlayerEditingSRTData =
  (data, videoFps, findFrameSplitValue, tProjectDetialId) => (dispatch) => {
    let newDataObjArray = new DataObjArray();

    let stringData = data.map((request) => {
      let beginFrameNumber = TimeUtils.getSRTFrameNumberFromString(
        request.start,
        videoFps
      );
      let endFrameNumber = TimeUtils.getSRTFrameNumberFromString(
        request.end,
        videoFps
      );

      //get frame number
      let durationFrame = endFrameNumber - beginFrameNumber;
      let duration = TimeUtils.getTimeStringFrom_FrameCount(
        durationFrame,
        videoFps
      );

      let start = TimeUtils.convertSecondToTimeString(request.start, videoFps);
      let end = TimeUtils.convertSecondToTimeString(request.end, videoFps);

      let newDataObj = new DataObj({
        tSubType: WaveformView.projectSubType,
        In: start,
        Out: end,
        start: request.start,
        end: request.end,
        ShotChange: "",
        Duration: duration,
        Memo: "",
        Source: "",
        SubtitleCaption:
          request.text === null ? "" : StringUtils.checkHTMLmark(request.text),
        Length: StringUtils.getStringLength(request.text),
        Position: "",
      });

      newDataObjArray.dataArry.push(newDataObj);

      return newDataObj;
    });

    newDataObjArray.addTenRow();

    //新增
    const jsonData = ApiUtils.post_sql(
      `${ApiUtils.post_AddDetialJsonData_email}`,
      {
        tProjectDetialId: tProjectDetialId,
        jsonstring: JSON.stringify(StringUtils.ZipUploadFile(newDataObjArray)),
        email: "",
      }
    );
    ApiUtils.checkSaveIsSuccess(jsonData);

    //顯查後更新
    finalEditTableCheckAndSave(
      dispatch,
      stringData,
      findFrameSplitValue,
      videoFps,
      0,
      data.length - 1
    );

    return stringData;
  };
 

/**
 * 上傳到後端，然後要更新
 * @param stringData 要存的資料
 * @param tProjectDetialId 專案
 * */
export const AddDetialJsonData =
  ({ jsonstring, tProjectDetialId, email }) =>
  async (dispatch) => {
    if (jsonstring !== null) {
      //新增
      const jsonData = await ApiUtils.post_sql(
        `${ApiUtils.post_AddDetialJsonData_email}`,
        {
          tProjectDetialId: tProjectDetialId,
          jsonstring: JSON.stringify(StringUtils.ZipUploadFile(jsonstring)),
          email: email,
        }
      );

      return ApiUtils.checkSaveIsSuccess(jsonData);
    }
  };

//移動frame
export const AddTC_FRAME =
  (stringData, findFrameSplitValue, videoFps, selectStart, way, row, col) =>
  (dispatch) => {
    //selectStart 選到的藍筐

    let newplayerEditingData = [];
    stringData.map((request, index) => {
      //工作的
      let dataObj = request;

      if (row === index) {
        let FrameNumber = 0;
        let newFrameNumber = 0;
        if (col === 0) {
          //開始時間
          FrameNumber = TimeUtils.timeString_convertTo_frame(dataObj.In);
        }

        if (col === 1) {
          //結束時間
          FrameNumber = TimeUtils.timeString_convertTo_frame(dataObj.Out);
        }

        newFrameNumber = FrameNumber + way * findFrameSplitValue;

        if (col === 0) {
          //開始時間
          dataObj.In = TimeUtils.getTimeStringFrom_FrameCount(
            newFrameNumber,
            videoFps
          );
        }

        if (col === 1) {
          //結束時間
          dataObj.Out = TimeUtils.getTimeStringFrom_FrameCount(
            newFrameNumber,
            videoFps
          );
        }
      }

      newplayerEditingData.push(dataObj);
    });

    //顯查後更新
    finalEditTableCheckAndSave(
      dispatch,
      stringData,
      findFrameSplitValue,
      videoFps,
      row,
      parseFloat(row) + 1
    );
  };
//最後的文字位移
export const MoveWordToFromNextRow =
  (stringData, findFrameSplitValue, videoFps, selectStart, way) =>
  (dispatch) => {
    //selectStart 選到的藍筐

    let newplayerEditingData = [];
    let FirstWord;
    let LastWord;
    stringData.map((request, index) => {
      //工作的
      let dataObj = request;
      let targetString = dataObj.SubtitleCaption;

      if (index === selectStart && index !== stringData.length - 1) {
        //下一個
        let nextIndex = index + 1;
        let nextObj = stringData[nextIndex];

        let nectString = nextObj.SubtitleCaption;

        if (way === "up") {
          //下一個字往上

          //下一段的第一個字
          FirstWord = StringUtils.getFirstWord(nectString);

          //把下一段文字 往上提升
          dataObj.SubtitleCaption = `${targetString} ${FirstWord}`;
        } else if (way === "down") {
          //下一個字往下
          LastWord = StringUtils.getLastWord(targetString);

          targetString = StringUtils.removeLastWord(targetString);

          dataObj.SubtitleCaption = targetString;
        }
      } else if (index === selectStart + 1 && index !== stringData.length - 1) {
        if (way === "up") {
          //下一個字往上

          //下一段的第一個字
          FirstWord = StringUtils.getFirstWord(targetString);

          targetString = StringUtils.removeFirstWord(targetString);

          //把下一段文字 往上提升
          dataObj.SubtitleCaption = targetString;
        } else if (way === "down") {
          //下一個字往下
          //把下一段文字 補充在最前端
          dataObj.SubtitleCaption = `${LastWord} ${targetString} `;
        }
      }

      newplayerEditingData.push(dataObj);
    });

    //顯查後更新
    finalEditTableCheckAndSave(
      dispatch,
      stringData,
      findFrameSplitValue,
      videoFps,
      selectStart,
      parseFloat(selectStart) + 1
    );
  };

/**
 * 複製所有字幕
 * */
export const copyToSource =
  (stringData, findFrameSplitValue, videoFps) => (dispatch) => {
    let newplayerEditingData = [];
    let SourceJSON = [];
    stringData.map((request) => {
      let dataObj = request;

      dataObj.Source = dataObj.SubtitleCaption;

      SourceJSON.push(dataObj.SubtitleCaption);

      newplayerEditingData.push(dataObj);
    });

    //顯查後更新
    finalEditTableCheckAndSave(
      dispatch,
      stringData,
      findFrameSplitValue,
      videoFps,
      0,
      stringData.length - 1
    );
  };

/**
 * 把原本的資源安裝上去
 * */
export const reloadSource = (stringData) => (dispatch) => {
  // let newplayerEditingData = stringData;
  //
  // const projectListDataString = localStorage.getItem('SourceJSON');
  //
  // //取得本地資料
  // let SourceJSONArray = JSON.parse(projectListDataString);
  //
  //
  // (SourceJSONArray).map((request,index ) => {
  //
  //     if(newplayerEditingData[index]){
  //         newplayerEditingData[index]['Source'] = request;
  //     }
  //
  // });
  //
  //
  //
  // //更新資料
  // dispatch({
  //     type: INIT_DATA,
  //     payload: newplayerEditingData
  // });
  //
  // return newplayerEditingData;
};

/**
 * 清除對照資源
 * */
export const deleteSource = (stringData) => (dispatch) => {
  // localStorage.setItem('SourceJSON', [])
  // //儲存本地
  // let newplayerEditingData = [];
  // (stringData).map((request ) => {
  //     let dataObj = request;
  //
  //     dataObj.Source = "";
  //
  //     newplayerEditingData.push(dataObj)
  // });
  //
  //
  // localStorage.removeItem("SourceJSON");
  //
  //
  // //更新資料
  // dispatch({
  //     type: INIT_DATA,
  //     payload: newplayerEditingData
  // });
};
/**
 * 設定表格最終資料 playerEditingData
 * */
export const setTableData =
  (stringData, findFrameSplitValue, videoFps, checkStartIndex, checkEndIndex) =>
  (dispatch) => {
    //顯查後更新
    finalEditTableCheckAndSave(
      dispatch,
      stringData,
      findFrameSplitValue,
      videoFps,
      checkStartIndex,
      checkEndIndex
    );
  };

/**
 * 直接更新
 * */
export const updateEditTableData = (stringData) => (dispatch) => {
  //更新資料
  dispatch({
    type: INIT_DATA,
    payload: stringData,
  });
};

/**
 *
 * @param {*} dispatch
 * @param {*} subListData 專案列表
 * @param {*} findFrameSplitValue
 * @param {*} videoFps
 * @param {*} checkStartIndex
 * @param {*} checkEndIndex
 * @returns
 */
function finalEditTableCheckAndSave(
  dispatch,
  subListData,
  findFrameSplitValue,
  videoFps,
  checkStartIndex,
  checkEndIndex
) {
  //更新Duration
  let newplayerEditingData = [];
  if (subListData !== null) {
    newplayerEditingData = subListData;

    for (let i = checkStartIndex; i <= checkEndIndex; i++) {
      if (!newplayerEditingData[i]) {
        return;
      }

      let dataObj = new DataObj(newplayerEditingData[i]);
      dataObj.setTSubType(WaveformView.projectSubType);

      newplayerEditingData[i] = dataObj;
    }
    // (playerEditingData).map((request,index  ) => {
    //
    //
    //     newplayerEditingData.push(dataObj)
    // });
  }

  /**
   * 先檢查尾部有多少資料是空的
   * */
  let AddNullCount = 0;

  for (let i = newplayerEditingData.length - 1; i >= 0; i--) {
    const dataObj = newplayerEditingData[i];

    const { In, Out } = dataObj;

    if (In === "" && Out === "") {
      AddNullCount += 1;
    } else {
      break;
    }
  }

  if (AddNullCount < 10) {
    for (let i = 0; i < 10 - AddNullCount; i++) {
      newplayerEditingData.push({
        In: "",
        Out: "",
        start: "",
        end: "",
        ShotChange: "",
        Duration: "",
        Memo: "",
        Source: "",
        SubtitleCaption: "",
        Length: "",
        Position: "",
      });
    }
  }

  // 更新資料
  dispatch({
    type: INIT_DATA,
    payload: newplayerEditingData,
  });
}



// WEBPACK FOOTER //
// ./src/actions/transOperationActions.js